import { Icon } from '@jutro/components';
import { TranslatorContext, withIntl } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { DatatableUtil, LobIconUtil, JobUtil } from '@xengage/gw-portals-util-js';
import cx from 'classnames';
import { AccountService } from 'gw-capability-gateway';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import gatewayMessages from '../../gateway.messages';
import messages from './OpenQuotes.messages';
import metadata from './OpenQuotes.metadata.json5';
import styles from './OpenQuotes.module.scss';

import { Link } from '@jutro/router';

class AccountOpenQuotes extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({
                accountNumber: PropTypes.string,
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        intl: PropTypes.func.isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        claimResponse: '',
        claimDataTable: '',
        selectedClaimLOB: 'All',
        searchFilter: '',
        quoteFilterOptions: [],
        pageConfig: {
            filterValue: "",
            page: 0,
            pageSize: 25
        }
    };

    componentDidMount() {
        const translator = this.context;
        const {
            authHeader,
            fromAccountLanding: {
                accountDetailsData: { accountNumber },
            },
        } = this.props;

        AccountService.findSubmissionSummariesByAccount(
            accountNumber,
            authHeader
        ).then(responseData => {
           const filteredResponseData = _.filter(responseData, item => item.status !== 'Bound')

            this.setState({
                claimResponse: filteredResponseData,
            });

            const response = this.getClaimModelResponse(filteredResponseData);
            const filter = {
                type: 'lobFilter',
                value: translator(messages.openQuotesOpenNotBoundLabel),
            };

            // this.getClaimDataTable(response, filter);
            this.getClaimDataTable(response, '');

            this.setState({
                claimResponse: response,
                selectedClaimLOB: 'All',
            });
        });
        this.getTransactionStatus();
    }

    getTransactionStatus = () => {
        const translator = this.context;
        const status = [
            {
                code: 'All',
                name: translator(messages.allStatus)
            },
            {
                code: 'Draft',
                name: translator(messages.draftStatus)
            },
            {
                code: 'Expired',
                name: translator(messages.expiredStatus)
            },
            {
                code: 'Quoted',
                name: translator(messages.quotedStatus)
            },
            {
                code: 'Submitted_Ext',
                name: translator(messages.offerSubmittedStatus),
            }
        ];

        this.setState({
            quoteFilterOptions: status
        });
    }

    // getDate = (dateValue) => {
    //     if (!dateValue) {
    //         return 'Invalid Date';
    //     }
    //     return TWIADateFormatUtil.formatDate(dateValue);
    // };

    findSubmissionSummariesByAccount = async () => {
        const response =
            await AccountService.findSubmissionSummariesByAccount();

        return response;
    };

    getClaimModelResponse = responseData => {
        const claimsData = responseData;

        return {
            claimsData,
            claimLOBOptions: this.getClaimLOBOptions(claimsData),
        };
    };

    isIssuedInLastXDays = (submission, days) =>
        moment().isSame(submission.closeDate, 'day') ||
        moment(submission.closeDate).isAfter(
            moment().subtract(days, 'days'),
            'day'
        );

    getLOBFilterValues = (claimsArrayResult, filter) => {
        const translator = this.context;

        if (filter.value === 'All') {
            return claimsArrayResult;
        }

        return claimsArrayResult.filter(activitiesInfo => {
            const isIssuedInLastXDays = 30;

            if (
                filter.value === translator(messages.openQuotesLastDaysLabel) &&
                activitiesInfo.policyIssued &&
                this.isIssuedInLastXDays(activitiesInfo, isIssuedInLastXDays)
            ) {
                this.setJobStatus(activitiesInfo);

                return true;
            }

            if (
                filter.value === translator(messages.openQuotesOpenBoundLabel)
            ) {
                return (
                    activitiesInfo.status ===
                    translator({
                        id: 'typekey.PolicyPeriodStatus.Bound',
                        defaultMessage: 'Bound',
                    }) &&
                    (!activitiesInfo.policyIssued || !activitiesInfo.closeDate)
                );
            }

            if (
                filter.value ===
                translator(messages.openQuotesOpenNotBoundLabel)
            ) {
                return (
                    activitiesInfo.status !==
                    translator({
                        id: 'typekey.PolicyPeriodStatus.Bound',
                        defaultMessage: 'Bound',
                    }) && !activitiesInfo.closeDate
                );
            }

            if (filter.value === 'Draft') {
                return (activitiesInfo.status === 'Draft' && (!activitiesInfo.policyIssued || !activitiesInfo.closeDate));
            }

            if (filter.value === 'Expired') {
                return (activitiesInfo.status === 'Expired' && (!activitiesInfo.policyIssued || !activitiesInfo.closeDate));
            }

            if (filter.value === 'Quoted') {
                return (activitiesInfo.status === 'Quoted' && (!activitiesInfo.policyIssued || !activitiesInfo.closeDate));
            }

            // DE16289
            if (filter.value === 'Submitted_Ext') {
                return ((activitiesInfo.status === 'Submitted_Ext' || activitiesInfo.status === 'Offer Submitted')
                    && (!activitiesInfo.policyIssued || !activitiesInfo.closeDate));
            }

            return false;
        });
    };

    getSearchFilterValues = (claimsArrayResult, filter) => {
        const { intl } = this.props;
        const lowerCaseFilterValue = filter.value.toLocaleLowerCase();
        const result = claimsArrayResult;

        if (filter === null) {
            return result;
        }

        return _.filter(result, res =>
            Object.keys(res).some(
                key =>
                    typeof res[key] === 'string' &&
                    res[key].toLocaleLowerCase().includes(lowerCaseFilterValue) &&
                    (filter.type != 'searchFilter' ||
                        (filter.type === 'searchFilter' && (key === 'quote' || key === 'created' || key === 'productType' || key === 'effDate' || key === 'status')))
            )
        );
    };

    setJobStatus = activitiesInfo => {
        const translator = this.context;

        if (activitiesInfo.policyIssued) {
            _.set(activitiesInfo, 'status', translator(gatewayMessages.issued));
        }

        if (activitiesInfo.status === 'Not-taken') {
            _.set(
                activitiesInfo,
                'status',
                translator(gatewayMessages.notTaken)
            );
        }
    };

    getClaimDataTable = (claimsData, filter) => {
        const { intl } = this.props;
        const { searchFilter } = this.state;
        let claimsArrayResult = claimsData.claimsData;

        claimsArrayResult = claimsArrayResult.map(claimInfo => {
            const claims = {
                created: intl.formatDate(
                    new Date(
                        claimInfo.createTime
                    ),
                    {
                        year: 'numeric',
                        month: 'numeric', // converting "Jan 01, 1999 to 1/1/1999"
                        day: 'numeric',
                    }
                ),
                canUserView: claimInfo.canUserView,
                product: claimInfo.product.productCode,
                quote: claimInfo.jobNumber,
                premium: claimInfo.totalPremium,
                status: claimInfo.status,
                productType: claimInfo.policyLine_TWIA.policyType_TWIA,
                propertyAddress: !_.isEmpty(claimInfo.address_TWIA) ? claimInfo.address_TWIA : '<empty>',
                effDate: intl.formatDate(
                    new Date(
                        claimInfo.policyEffectiveDate
                    ),
                    {
                        year: 'numeric',
                        month: 'numeric', // converting "Jan 01, 1999 to 1/1/1999"
                        day: 'numeric',
                    }
                )
            };

            return claims;
        });

        const combineFilter = {};

        switch (filter.type) {
            case 'lobFilter':
                claimsArrayResult = this.getLOBFilterValues(
                    claimsArrayResult,
                    filter
                );

                if (searchFilter && claimsArrayResult) {
                    combineFilter.value = searchFilter;
                    claimsArrayResult = this.getSearchFilterValues(
                        claimsArrayResult,
                        combineFilter
                    );
                }

                break;
            case 'searchFilter':
                claimsArrayResult = this.getSearchFilterValues(
                    claimsArrayResult,
                    filter
                );

                if (
                    typeof this.selectedClaimLOB === 'string' &&
                    this.selectedClaimLOB !== 'Filters'
                ) {
                    combineFilter.value = this.selectedClaimLOB;
                    claimsArrayResult = this.getLOBFilterValues(
                        claimsArrayResult,
                        combineFilter
                    );
                }

                break;
            case null:
                if (searchFilter) {
                    combineFilter.value = searchFilter;
                    claimsArrayResult = this.getSearchFilterValues(
                        claimsArrayResult,
                        combineFilter
                    );
                }

                break;
            default:
                break;
        }

        this.setState({
            claimDataTable: claimsArrayResult,
        });

        const { pageConfig } = this.state

        // 2025-03-26 - Debra Frum - DE16352 - Open Transactions filter not displaying results when more than one page of data
        // Removed the if statement so that the page number is reset to 0 when a filter is changed and the search results  
        // contain any number of pages, not just 2 pages.
        // if (claimsArrayResult.length <= 25) {
            pageConfig.page = 0
        // }

        this.setState({
            pageConfig
        })
    };

    getClaimLOBOptions = response => {
        const translator = this.context;
        const claimLOBOptionsArray = [
            translator(messages.openQuotesLastDaysLabel),
            translator(messages.openQuotesOpenNotBoundLabel),
            translator(messages.openQuotesOpenBoundLabel),
        ];

        if (_.isEmpty(response)) {
            return [];
        }

        return claimLOBOptionsArray.map(key => ({
            code: key,
            name: key,
        }));
    };

    handleNewQuoteClick = () => {
        const {
            history,
            fromAccountLanding: {
                accountDetailsData: { accountNumber },
            },
        } = this.props;

        return history.push(`/new-quote/${accountNumber}`);
    };

    handleFilterChange = (value, id) => {
        const { claimResponse } = this.state;
        const filter = {
            type: null,
            value: null,
        };

        if (id === 'lobFilter') {
            if (value !== 'Filters') {
                filter.type = 'lobFilter';
                filter.value = value;
            }

            this.setState(
                {
                    selectedClaimLOB: value,
                },
                () => {
                    this.getClaimDataTable(claimResponse, filter);
                }
            );
        }

        if (id === 'searchFilter') {
            filter.type = 'searchFilter';
            filter.value = value;
            this.setState(
                {
                    searchFilter: value,
                },
                () => {
                    this.getClaimDataTable(claimResponse, filter);
                }
            );
        }
    };

    getCell = (items, index, property) => {
        const translator = this.context;
        const toolTipMessage = {
            status: translator(messages.openQuoteStatusLabel),
            created: translator(messages.openQuotesCreatedLabel),
        };

        return (
            <span title={toolTipMessage[property.id]}>
                {items[property.id]}
            </span>
        );
    };

    getLink = (item, index, property) => {
        const translator = this.context;
        const toolTipMessage = translator(messages.openQuoteLabel);

        if (item.canUserView) {
            return (
                <span title={toolTipMessage}>
                    <Link to={`/quotes/${item[property.id]}/summary`}>
                        {item[property.id]}
                    </Link>
                </span>
            );
        }
        
        return <span>{item[property.id]}</span>;
    };

    getCurrency = (item, index, property) => {
        const translator = this.context;
        const toolTipMessage = translator(messages.premium);

        return (
            <span title={toolTipMessage}>
                <CurrencyField
                    id={`currency_${index}`}
                    value={item[property.id]}
                    readOnly
                    hideLabel
                    showOptional={false}
                    className={styles.currencyColumn}
                />
            </span>
        );
    };

    getMetadataImplementation = () => {
        const resolvers = {
            resolveClassNameMap: styles,
        };

        return (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={{}}
                {...resolvers}
            />
        );
    };

    getProductImage = item => {
        const icon = LobIconUtil.getFontIcon(item.product);

        return <Icon icon={icon} title={item.product} />;
    };

    render() {
        const {
            claimResponse,
            claimDataTable,
            selectedClaimLOB,
            searchFilter,
            quoteFilterOptions
        } = this.state;

        if (_.isEmpty(claimResponse)) {
            return null;
        }


        const overrides = {
            quoteDataTable: {
                data: claimDataTable,
                config: this.state.pageConfig,
                onConfigChange: (data) => {
                    const pageConfig = _.clone(data)

                    if (claimDataTable.length <= 25) {
                        pageConfig.page = 0
                    }

                    this.setState({
                        pageConfig
                    })
                }
            },
            lobFilter: {
                // availableValues: claimResponse.claimLOBOptions,
                availableValues: quoteFilterOptions,
                value: selectedClaimLOB,
            },
            searchFilter: {
                value: searchFilter,
            },
        };
        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell: this.getCell,
                getLink: this.getLink,
                getProductImage: this.getProductImage,
                getCurrency: this.getCurrency,
                handleLobValueChange: value =>
                    this.handleFilterChange(value, 'lobFilter'),
                handleSearchValueChange: value =>
                    this.handleFilterChange(value, 'searchFilter'),
                handleNewQuoteClick: this.handleNewQuoteClick,
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortNumber: DatatableUtil.sortNumber,
                sortCurrency: DatatableUtil.sortCurrency,
            },
        };
        const claimPage = (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );

        return <div className={cx(styles.summary)}>{claimPage}</div>;
    }
}

export const AccountOpenQuotesComponent = AccountOpenQuotes;
export default withIntl(withAuthenticationContext(AccountOpenQuotes));
